export default __webpack_public_path__ + "static/media/C.4e40f7d0.svg";